import { Input, Modal } from "antd";
import { Dispatch, SetStateAction } from "react";
import { SelectedMandateItemProps } from "./DirectDebit";
import styles from "./DirectDebitStyles.module.scss";

interface RejectMandateProps {
    showRejectModal: boolean;
    setShowRejectModal: Dispatch<SetStateAction<boolean>>
    rejectReason: string;
    setRejectReason: Dispatch<SetStateAction<string>>;
    rejectLoading: boolean;
    selectedMandateItem: SelectedMandateItemProps | null;
    handleMandateRejection: () => void
    rejectErrorMsg?: string;
}

const RejectMandate = ({
    showRejectModal,
    setShowRejectModal,
    rejectReason,
    setRejectReason,
    rejectLoading,
    selectedMandateItem,
    handleMandateRejection,
    rejectErrorMsg
}: RejectMandateProps) => {
    return (
        <Modal
            title="State reason for declining Mandate"
            open={showRejectModal}
            zIndex={9990}
            onCancel={() => setShowRejectModal(false)}
            footer={[
                selectedMandateItem?.direct_debit_mandate_status?.toLowerCase()?.trim() === "declinedbycredit" ?
                    null :
                    <button
                        key="submit"
                        className={`btn advancly-btn ${styles.reject_btn}`}
                        disabled={!rejectReason}
                        onClick={handleMandateRejection}
                    >
                        {rejectLoading ? "Submitting..." : "Send"}
                    </button>,
            ]}
        >
            {rejectErrorMsg && (
                <p className="alert alert-danger py-2">
                    {rejectErrorMsg}
                </p>
            )}
            {selectedMandateItem?.decline_comment ? (
                <p>{selectedMandateItem.decline_comment}</p>
            ) : (
                <>
                    <p>Please provide a reason for rejecting this mandate:</p>

                    <Input.TextArea
                        rows={4}
                        value={rejectReason}
                        onChange={(e) => setRejectReason(e.target.value)}
                        placeholder="Type your rejection reason..."
                    />
                </>
            )
            }
        </Modal>

    )
}

export default RejectMandate